import React, {useContext} from 'react'
import useListChallengedDecisions from "./useListChallengedDecisions";
import {useStyles} from "./ChallengedDecisionsSection.css";
import {StyledTableCell, StyledTableRow} from "../../../../commons/utils/table/StyledTableSecondary.css";
import Paper from "@mui/material/Paper";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import LoadingProgressIndication from "../../../../commons/elements/progress/loading/LoadingProgressIndication";
import {useIntl} from "react-intl";
import ScoredSceneSummarySlider from "../../videosScored/utils/sliders/ScoredSceneSummarySlider";
import {NavLink} from "react-router-dom";
import {IconButton} from "@mui/material";
import {Close, Refresh} from "@mui/icons-material";
import ChallengedDecisionStatusIndication from "../../../../commons/utils/status/challengedDecision/ChallengedDecisionStatusIndication";
import {FirebaseAuthContext} from "../../../../commons/firebase/FirebaseAuthProvider";

const ChallengedDecisionsSection = ({scoredScene, onStatusUpdate}) => {
    const classes = useStyles();

    const {
        challengedDecisions,
        loading,
        toggleChallengedDecisionStatus
    } = useListChallengedDecisions(scoredScene.key)

    // Internationalization for simple strings
    const intl = useIntl();

    // Checking if the edit/saving operations are allowed
    const {isOperationOnObjectAllowed} = useContext(FirebaseAuthContext);

    // Show loading indication while loading the list of users
    if (loading) {
        return <LoadingProgressIndication
            text={intl.formatMessage({
                id: 'app.challengedDecision.overview.challengedDecisions.loading',
                defaultMessage: 'Loading Challenged Decisions...'
            })}/>
    }

    return (
        <Paper className={classes.root}>
            <TableContainer component={Paper}>
                <Table size="small">

                    {/* Table header */}
                    <TableHead>
                        <TableRow>
                            <StyledTableCell align={"center"} width={"25%"} key='scoreSummary'>
                                {intl.formatMessage({
                                    id: 'app.challengedDecision.overview.table.expanded.table.column.scoreSummary',
                                    defaultMessage: 'Score Summary'
                                })}
                            </StyledTableCell>
                            <StyledTableCell align={"center"} width={"20%"} key='claimingUser'>
                                {intl.formatMessage({
                                    id: 'app.challengedDecision.overview.table.expanded.table.column.claimingUser',
                                    defaultMessage: 'Claiming User'
                                })}
                            </StyledTableCell>
                            <StyledTableCell align={"center"} width={"30%"} key='comment'>
                                {intl.formatMessage({
                                    id: 'app.challengedDecision.overview.table.expanded.table.column.comment',
                                    defaultMessage: 'Comment'
                                })}
                            </StyledTableCell>
                            <StyledTableCell align={"center"} width={"10%"} key='status'>
                                {intl.formatMessage({
                                    id: 'app.challengedDecision.overview.table.expanded.table.column.status',
                                    defaultMessage: 'Status'
                                })}
                            </StyledTableCell>
                            <StyledTableCell align={"right"} width={"15%"} key='actions'>
                                {intl.formatMessage({
                                    id: 'app.challengedDecision.overview.table.expanded.table.column.actions',
                                    defaultMessage: 'Actions'
                                })}
                            </StyledTableCell>
                        </TableRow>
                    </TableHead>

                    {/* Table rows */}
                    <TableBody>
                        {challengedDecisions.map((challengedDecision) => {
                            return (
                                <StyledTableRow hover role="checkbox" tabIndex={-1} key={challengedDecision.key}>

                                    {/* Score summary "slider" */}
                                    <StyledTableCell key='scoreSummary' align={"center"}>
                                        <div className={classes.scoreSummaryRow}>
                                            <ScoredSceneSummarySlider scoredScene={scoredScene} timeFormat="mm:ss:SS"
                                                                      challengedDecision={challengedDecision}/>
                                        </div>
                                    </StyledTableCell>
                                    <StyledTableCell key='claimingUser' align={"center"}>
                                        <NavLink to={`/admin/users/${challengedDecision.userId}/edit`}>
                                            {`${challengedDecision.user.firstName} ${challengedDecision.user.secondName}`}
                                        </NavLink>
                                    </StyledTableCell>
                                    <StyledTableCell key='comment' align={"center"}>
                                        {challengedDecision.playerNotes}
                                    </StyledTableCell>
                                    <StyledTableCell key='status' align={"center"}>
                                        <ChallengedDecisionStatusIndication isClosed={challengedDecision.closed}/>
                                    </StyledTableCell>
                                    <StyledTableCell key='actions' align={"right"}>
                                        <IconButton
                                            onClick={() => {
                                                toggleChallengedDecisionStatus(challengedDecision.key)
                                                    .then(() => onStatusUpdate())
                                            }}
                                            disabled={!isOperationOnObjectAllowed(scoredScene)}
                                            size="large">
                                            {challengedDecision.closed
                                                ? <Refresh/>
                                                : <Close/>}
                                        </IconButton>
                                    </StyledTableCell>
                                </StyledTableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    );
}

export default ChallengedDecisionsSection
